import React from 'react';
import Scrollbar from '../../../../Scrollbar';
// material
import {
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    TableContainer,
    Box,
    Typography
} from '@mui/material';

const SessionTable = ({ tableData }) => {

    const isUserNotFound = tableData?.length === 0;

    return (
        <>
            <Box >
                <Scrollbar>
                    <TableContainer sx={{ overflow: 'unset' }} >
                        <Table>
                            <TableHead>
                                <TableRow >
                                    <TableCell >
                                        <Box sx={{ width: 'fit-content', display: 'flex' }}>
                                            <Typography variant='t13_600' >
                                                {'Menu Name'}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell width='150px'>
                                        <Box sx={{ width: 'fit-content', display: 'flex' }}>
                                            <Typography variant='t13_600' >
                                                {'Total Quantity'}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.map(m =>
                                    <TableRow key={m.menuName}>
                                        <TableCell align="left">
                                            <Typography variant='t12_500' >
                                                {m.menuName}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography variant='t12_500' >
                                                {m.availableQuantity}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
        </>
    )
}

export default SessionTable;